import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../../context/LanguageContext";

const WhyTradeForex = ({ cardData, subtitle, title }) => {
  const theme = useTheme();
  const { language, translations } = useLanguage();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const renderDescription = (desc) => {
    return desc.split("<br/>").map((line, i) => (
      <React.Fragment key={i}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: false, // whether animation should happen only once
    });
  }, []);

  return (
    <Container maxWidth="xl">
      <Box mt={4} sx={{ py: { xs: 4, md: 8 } }}>
        <Box sx={{ px: { xs: 2, md: 8 } }}>
          {" "}
          <Box  textAlign={{ xs: "center", md: "start" }}>
            <Typography variant="h3" style={{ color: "rgba(26, 28, 30, 1)" }}>
              {title ?? translations[language]?.whyTrade}
            </Typography>
            <Typography
              sx={{
                fontSize: "22px",
                color: "rgba(102, 112, 133, 1)",
                fontWeight: "400",
                fontFamily: "SF Pro Display",
                mt: 2,
                width: { xs: "100%", md: "780px" },
              }}
            >
              {subtitle ??
                translations[language]?.whyTradeSub}
            </Typography>
          </Box>
          <Grid container spacing={3} mt={6} >
            {cardData?.map((card, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                key={index}
                display="flex"
                justifyContent="center"
              >
                <Card
                  // data-aos="fade-left"
                  elevation={0}
                  sx={{
                    bgcolor: "#F6F9FC",
                    borderRadius: "20px",
                    height: "100%",
                    px: 3,
                    pt:4,
                    pb:6,
                    // py: 4,
                    width: {
                      xs: "100%",
                      sm: "322px",
                      md: "386px",
                      lg: "660px",
                    },
                    maxWidth: 660, // optional: limit card width
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardContent sx={{ py: 0, width: "100%" }}>
                    <Stack spacing={2} alignItems="flex-start">
                      <Box
                        component="img"
                        src={card?.logo}
                        alt="logo"
                        width={40}
                        height={40}
                        sx={{objectFit:'contain'}}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          fontSize: {
                            xs: "22px !important",
                            sm: "22px",
                            md: "30px",
                            lg: "30px",
                          },
                          color: "#000",
                          paddingTop: "10px",
                        }}
                      >
                        {card.heading}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "19px !important",
                            sm: "22px",
                            md: "24px",
                            lg: "24px",
                          },
                          color: "rgba(102, 112, 133, 1)",
                          lineHeight: {md:"24px !important",xs:"26px !important"},
                          fontWeight: "500",
                        }}
                      >
                        {renderDescription(card.description)}
                      </Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default WhyTradeForex;
